import * as React from 'react';
import Head from 'next/head';
export function RobotDirectives({ values }) {
    if ((values === null || values === void 0 ? void 0 : values.length) === 0) {
        return null;
    }
    const directives = values.join(', ');
    return (React.createElement(Head, null,
        React.createElement("meta", { name: "robots", content: directives })));
}
